import { createStore, combineReducers, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';

import rootSaga from './sagas';
import loginR from './reducers/login';
import clientR from './reducers/client';
import branchR from './reducers/branch';
import roomR from './reducers/room';
import voucherR from './reducers/voucher';
import dashboardR from './reducers/dashboard';

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  combineReducers({
    loginR,
    clientR,
    branchR,
    roomR,
    voucherR,
    dashboardR
  }),
  applyMiddleware(sagaMiddleware),
);

sagaMiddleware.run(rootSaga);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js